import type { Locale } from 'date-fns/locale'
import { enUS } from 'date-fns/locale/en-US'
import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

async function loadLocale(
  lang: string | undefined,
  ready: boolean,
): Promise<Locale> {
  return ready
    ? lang === 'zh'
      ? (await import('date-fns/locale/zh-CN')).zhCN
      : enUS
    : enUS
}

export function useDateFnsLocale() {
  const { i18n, ready } = useTranslation()
  const [locale, setLocale] = useState(enUS)

  useEffect(() => {
    loadLocale(i18n?.language, ready).then((locale) => setLocale(locale))
  }, [i18n?.language, ready])

  return locale
}
